import { linkTo, usePathParams } from 'components/Router/paths';
import React from 'react';
import { Redirect } from 'react-router';

export default function Integrations(): JSX.Element {
  const { orgId, teamId } = usePathParams('integrations');
  return <Redirect to={linkTo('workspace', { orgId, teamId }, '?tab=Integrations')} />;
}
